import React from 'react';
import { BrowserRouter, Routes, Route, useLocation, Navigate, Outlet } from 'react-router-dom';
import { ServerList } from './components/layout/ServerList';
import { ChannelList } from './components/layout/ChannelList';
import { ProfileNav } from './components/profile/ProfileNav';
import { Feed } from './components/feed/Feed';
import { ChatRoom } from './components/chat/ChatRoom';
import { UserProfile } from './components/profile/UserProfile';
import { PublicProfile } from './components/profile/PublicProfile';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { AuthForm } from './components/auth/AuthForm';
import { DirectMessages } from './components/chat/DirectMessages';
import { FollowRequests } from './components/profile/FollowRequests';

function Layout() {
  const location = useLocation();
  const isContentView = location.pathname.split('/').length > 3;

  return (
    <div className="flex bg-background-primary text-text-primary min-h-screen">
      {/* Server list - hidden on mobile in content view */}
      <div className={`${isContentView ? 'hidden md:block' : ''} flex-shrink-0`}>
        <ServerList />
      </div>
      <div className="flex-1">
        <Outlet />
      </div>
    </div>
  );
}

function ServerLayout() {
  const location = useLocation();
  const isContentView = location.pathname.split('/').length > 3;

  return (
    <div className="flex h-screen">
      {/* Channel list - hidden on mobile in content view */}
      <div className={`${isContentView ? 'hidden md:block' : 'w-full'} md:w-60`}>
        <ChannelList />
      </div>
      {/* Content area - full width on mobile in content view */}
      <div className={`${isContentView ? 'w-full' : 'hidden'} md:flex-1`}>
        <Outlet />
      </div>
    </div>
  );
}

function ProfileLayout() {
  const location = useLocation();
  const isContentView = location.pathname.split('/').length > 3;

  return (
    <div className="flex h-screen">
      {/* Profile nav - hidden on mobile in content view */}
      <div className={`${isContentView ? 'hidden md:block' : 'w-full'} md:w-60`}>
        <ProfileNav />
      </div>
      {/* Content area - full width on mobile in content view */}
      <div className={`${isContentView ? 'w-full' : 'hidden'} md:flex-1`}>
        <Outlet />
      </div>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Root route redirects to auth if not logged in */}
          <Route path="/" element={<Navigate to="/auth" replace />} />
          
          <Route path="/auth" element={<AuthForm />} />
          <Route path="/app" element={<Navigate to="/app/profile/feed" replace />} />
          <Route path="/u/:username" element={<PublicProfile />} />
          
          <Route path="/app" element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }>
            <Route path="chat" element={<ServerLayout />}>
              <Route index element={<ChatRoom />} />
              <Route path=":channelId" element={<ChatRoom />} />
            </Route>

            <Route path="artist-hub" element={<ServerLayout />}>
              <Route index element={<ChatRoom />} />
              <Route path=":channelId" element={<ChatRoom />} />
            </Route>

            <Route path="producer-hub" element={<ServerLayout />}>
              <Route index element={<ChatRoom />} />
              <Route path=":channelId" element={<ChatRoom />} />
            </Route>

            <Route path="profile" element={<ProfileLayout />}>
              <Route index element={<UserProfile />} />
              <Route path="edit" element={<UserProfile />} />
              <Route path="feed" element={<Feed />} />
              <Route path="messages" element={<DirectMessages />} />
              <Route path="messages/:username" element={<DirectMessages />} />
              <Route path="follow-requests" element={<FollowRequests />} />
              <Route path="settings" element={<UserProfile />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}